import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useCities() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('cities')
        .select('id, name')
        .eq('is_active', true)
        .order('name');
      if (error) setError(error.message);
      else setCities(data || []);
      setLoading(false);
    };
    fetch();
  }, []);

  return { cities, loading, error };
}

export function useLocalities(cityId) {
  const [localities, setLocalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!cityId) {
      setLocalities([]);
      return;
    }
    const fetch = async () => {
      setLoading(true);
      setError(null);
      const { data, error } = await supabase
        .from('localities')
        .select('id, name')
        .eq('city_id', cityId)
        .eq('is_active', true)
        .order('name');
      if (error) setError(error.message);
      else setLocalities(data || []);
      setLoading(false);
    };
    fetch();
  }, [cityId]);

  return { localities, loading, error };
}